/* eslint-disable max-lines */
import { all, call, put } from 'redux-saga/effects'

import routes, { Router } from '../../routes'
import i18n from '../../i18n'
import { app } from '../../configuration'
import { actions as appActions } from '../../redux/app/redux'


export default class ApplicationCvSagas {

  static* init() {
    return yield call(ApplicationCvSagas.setupSeo)
  }

  static* setupSeo() {
    yield put(
      appActions.setSeo({
        title: i18n.t('SEO_applicationCv_title'),
        description: i18n.t('SEO_applicationCv_description'),
        keywords: i18n.t('SEO_applicationCv_keywords'),
        url: `${app.APP_URL}${Router.getRouteUrl(routes.applicationCv)}`,
        noindex: false,
      })
    )
  }

  static* loop() {
    yield all([
      //
    ])
  }

}
